import { Box, Divider, Grid, Skeleton } from '@mui/material';
import _ from 'lodash';
import { FormFieldSkeleton } from '../../../components/form-field-skeleton/FormFieldSkeleton';

export const AdminRegistrationPageSkeleton: React.FC = () => {
  return (
    <Box>
      <Box
        className="container-fluid"
        sx={{
          bgcolor: 'grey.50',
          borderBottomLeftRadius: { xs: '5rem', sm: '50%' },
          borderBottomRightRadius: { xs: '5rem', sm: '50%' },
          py: 4,
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <Skeleton variant="rectangular" height="12.5rem" width="12.5rem" />
          <Skeleton variant="rectangular" height="3rem" width="min(90%, 25rem)" sx={{ mt: 5, mb: 1.5 }} />
          <Skeleton variant="text" width="min(80%, 20rem)" />
          <Skeleton variant="text" width="min(50%, 10rem)" />
        </Box>
      </Box>
      <Box sx={{ mt: 4, mb: 7.5 }} className="container-fluid">
        <Box sx={{ mb: 2.5 }}>
          <Skeleton variant="text" height="3rem" width="7.5rem" />
          <Skeleton variant="rectangular" height="0.5rem" width="2rem" />
        </Box>
        <Grid container spacing={2.5}>
          {_.times(4).map((_item, index) => (
            <Grid item key={index} xs={12} md={6}>
              <FormFieldSkeleton />
            </Grid>
          ))}
        </Grid>
        <Divider sx={{ my: 4 }} />
        <Box sx={{ mb: 2.5 }}>
          <Skeleton variant="text" height="3rem" width="7.5rem" />
          <Skeleton variant="rectangular" height="0.5rem" width="2rem" />
        </Box>
        <Grid container spacing={2.5}>
          {_.times(4).map((_item, index) => (
            <Grid item key={index} xs={12} md={6}>
              <FormFieldSkeleton />
            </Grid>
          ))}
          <Grid item xs={12} md={6}>
            <FormFieldSkeleton fieldType="file" />
          </Grid>
          <Grid item xs={12} md={6}>
            <FormFieldSkeleton fieldType="location" />
          </Grid>
        </Grid>
        <Skeleton sx={{ mt: 2.5 }} variant="rectangular" height="2.5rem" width="7.5rem" />
      </Box>
    </Box>
  );
};
